import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  email: null,
  error: null,
  userInfo: {
    userId: null,
    firstName: null,
    lastName: null,
    token: null,
  },
  loggedIn: false,
  forgotPasswordLoading: false,
  forgotPasswordSuccess: false,
  forgotPasswordError: null,
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    submitLoginRequest: (state, action) => {
      state.email = action.payload?.email || null;
      state.error = null;
    },
    loginSuccess: (state, action) => {
      state.loading = false;
      const payload = action.payload || {};
      const supplierData =
        payload.supplierData && payload.supplierData[0]
          ? payload.supplierData[0]
          : {};
      state.userInfo = {
        ...payload,
        userId: payload._id || null,
        supplierId: supplierData._id || null,
        supplierName: supplierData.name || null,
        factoryId: payload.factoryId || null,
      };
      state.email = payload.email || state.email;
      state.loggedIn = true;
      state.error = null;
    },
    loginFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload || null;
    },
    logout: (state) => {
      localStorage.removeItem("loginState"); // Clear local storage
      state.email = null;
      state.userInfo = {
        userId: null,
        firstName: null,
        lastName: null,
        token: null,
      };
      state.loggedIn = false;
    },
    getOrganisationResources: (state, action) => {},
    setOrganisationResources: (state, action) => {
      state.userInfo.resources = action.payload;
    },
    updateProfileInfo: (state, action) => {},
    updateProfileInfoSuccess: (state, action) => {
      state.userInfo.firstName = action.payload.firstName;
      state.userInfo.lastName = action.payload.lastName;
    },
    updatePassword: (state, action) => {},
    updatePasswordForFirstTime: (state, action) => {},
    updatePasswordForFirstTimeSuccess: (state, action) => {
      state.userInfo.updatedPassword = true;
    },
    submitForgotPasswordRequest: (state) => {
      state.forgotPasswordLoading = true;
      state.forgotPasswordError = null;
      state.forgotPasswordSuccess = false;
    },
    forgotPasswordSuccess: (state) => {
      state.forgotPasswordLoading = false;
      state.forgotPasswordSuccess = true;
    },
    forgotPasswordFailure: (state, action) => {
      state.forgotPasswordLoading = false;
      state.forgotPasswordError = action.payload;
    },
    verifyCodeRequest: (state) => {
      state.forgotPasswordLoading = true;
      state.forgotPasswordError = null;
    },
    resetPasswordRequest: (state) => {
      state.forgotPasswordLoading = true;
      state.forgotPasswordError = null;
    },
    clearForgotPasswordError: (state) => {
      state.forgotPasswordError = null;
      state.forgotPasswordSuccess = false;
    },
  },
});

export const {
  submitLoginRequest,
  loginSuccess,
  loginFailure,
  logout,
  getOrganisationResources,
  setOrganisationResources,
  updateProfileInfo,
  updateProfileInfoSuccess,
  updatePassword,
  updatePasswordForFirstTime,
  updatePasswordForFirstTimeSuccess,
  submitForgotPasswordRequest,
  forgotPasswordSuccess,
  forgotPasswordFailure,
  verifyCodeRequest,
  resetPasswordRequest,
  clearForgotPasswordError,
} = loginSlice.actions;

export default loginSlice.reducer;
